<template>
    <layout-basic>
        <div id="notification-sec">
            <template>
                <v-tabs v-model="tab" class="sticky" data-tour="settings-tabs">
                    <v-tabs-slider class="notification-tab-slider"></v-tabs-slider>
                    <v-tab>Notification</v-tab>
                    <v-tab>Certificate</v-tab>
                    <v-tab>{{ $globalConfig.APP_NAME === 'senso' ? 'Sites' : 'Locations'}}</v-tab>
                </v-tabs>
            </template>
            <v-tabs-items v-model="tab">
                <v-tab-item transition="false" reverse-transition="false" class="notification-tab">
                    <v-card flat>
                        <v-card-text>
                            <Notifications/>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item   transition="false" reverse-transition="false" class="certificate-tab">
                    <v-card flat>
                        <v-card-text>
                            <NewCertificate/>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item transition="false" reverse-transition="false" class="site-tab">
                    <v-card flat>
                        <v-card-text>
                            <Site/>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </layout-basic>
</template>
<script>
import LayoutBasic from '@/layouts/Dashboard';
import Notifications from '@/components/Notifications'
import NewCertificate from '@/components/NewCertificate'
import Site from '@/components/Site'

export default {
    name: 'Settings',
    components: {
        LayoutBasic,
        Notifications,
        NewCertificate,
        Site
    },
    data() {
        return {
            tab: null,
        }
    }
}
</script>

<style scoped>
.container{
    padding: 12px;
}
.sticky{
  position: fixed;
  top: 64px;
  z-index: 10;
  background-color: white;
  padding: 10px 10px 0;  
  /* A fixed block with no width spans the whole viewport from its static x
     (256px, beside the drawer), so the bar ran 256px past the right edge.
     Size it to the content area instead (17 Sep 2026). */
  left: auto;
  right: 0;
  width: calc(100% - 256px);
  box-sizing: border-box;
}
@media (max-width: 1263px) {
  .sticky{
    left: 0;
    right: auto;
    width: 100%;
  }
}

.notification-tab{
    padding: 60px 42px 10px; 
    margin-bottom: 48px;
}

.certificate-tab{
    padding: 42px 0px;
}

.site-tab{
    padding: 66px 20px 0 20px;
}

@media screen and (max-width: 960px) {
  .sticky{
    top: 56px;
  }

  .notification-tab{
    padding: 60px 0px;
    margin-bottom: 0;
  } 

  .certificate-tab{
     padding: 60px 0px;
  }

  .site-tab{
    padding: 60px 0px;
  }
}

@media screen and (max-width: 460px) {
  .sticky{
    height: 105px;
  }

  .notification-tab{
    padding: 100px 0px;
    margin-bottom: 0;
  }

    .site-tab,
    .certificate-tab{
        padding: 100px 0px;
    }
}

</style>